import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import { TextLink } from "./Button"
import ArticlePreview from "./ArticlePreview"

import ArrowheadFatLeft from "./Icon/ArrowheadFatLeft"

const Organisation = () => (
	<>
		<h1 className="mb-20 font-bold text-base text-jetblack">Cloud Organisation</h1>
		<ul role="menubar">
			<li className="navigation">
				<Link
					to="/cloud-organisation/portal"
					className="link"
					role="menuitem"
					activeClassName="active">
					Portal
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-organisation/partner-portal"
					className="link"
					role="menuitem"
					activeClassName="active">
					Partner Portal
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-organisation/employees"
					className="link"
					role="menuitem"
					activeClassName="active">
					Employees
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-organisation/files"
					className="link"
					role="menuitem"
					activeClassName="active">
					Files
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-organisation/users"
					className="link"
					role="menuitem"
					activeClassName="active">
					Users
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-organisation/companies"
					className="link"
					role="menuitem"
					activeClassName="active">
					Companies
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-organisation/templates"
					className="link"
					role="menuitem"
					activeClassName="active">
					Templates
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-organisation/vessel-particulars"
					className="link"
					role="menuitem"
					activeClassName="active">
					Vessel Particulars
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-organisation/ports-and-yards"
					className="link"
					role="menuitem"
					activeClassName="active">
					Ports & Yards
				</Link>
			</li>
		</ul>
	</>
)

const Crewing = () => (
	<>
		<h1 className="mb-20 font-bold text-base text-jetblack">Cloud Crewing</h1>
		<ul>
			<li className="navigation">
				<Link
					to="/cloud-crewing/crewing"
					className="link"
					role="menuitem"
					activeClassName="active">
					Crewing
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-crewing/crew-portal"
					className="link"
					role="menuitem"
					activeClassName="active">
					Crew Portal
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-crewing/cashbox-and-bonded-store"
					className="link"
					role="menuitem"
					activeClassName="active">
					Cashbox & Bonded Store
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-crewing/accommodations"
					className="link"
					role="menuitem"
					activeClassName="active">
					Accommodations
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-crewing/medical-logbook"
					className="link"
					role="menuitem"
					activeClassName="active">
					Medical Logbook
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-crewing/pharmacy"
					className="link"
					role="menuitem"
					activeClassName="active">
					Pharmacy
				</Link>
			</li>
		</ul>
	</>
)

const QHSE = () => (
	<>
		<h1 className="mb-20 font-bold text-base text-jetblack">Cloud QHSE</h1>
		<ul>
			<li className="navigation">
				<Link
					to="/cloud-qhse/circulars"
					className="link"
					role="menuitem"
					activeClassName="active">
					Circulars
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-qhse/emergencies"
					className="link"
					role="menuitem"
					activeClassName="active">
					Emergencies
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-qhse/ihm"
					className="link"
					role="menuitem"
					activeClassName="active">
					IHM
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-qhse/incidents"
					className="link"
					role="menuitem"
					activeClassName="active">
					Incidents
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-qhse/inspections-and-audits"
					className="link"
					role="menuitem"
					activeClassName="active">
					Inspections & Audits
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-qhse/inspection-report"
					className="link"
					role="menuitem"
					activeClassName="active">
					Inspection Report
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-qhse/procedures"
					className="link"
					role="menuitem"
					activeClassName="active">
					Procedures
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-qhse/risk-assessment"
					className="link"
					role="menuitem"
					activeClassName="active">
					Risk Assessment
				</Link>
			</li>
		</ul>
	</>
)

const Technical = () => (
	<>
		<h1 className="mb-20 font-bold text-base text-jetblack">Cloud Technical</h1>
		<ul>
			<li className="navigation">
				<Link
					to="/cloud-technical/blog"
					className="link"
					role="menuitem"
					activeClassName="active">
					Blog
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-technical/bunker"
					className="link"
					role="menuitem"
					activeClassName="active">
					Bunker
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-technical/certificates"
					className="link"
					role="menuitem"
					activeClassName="active">
					Certificates
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-technical/disturbance-report"
					className="link"
					role="menuitem"
					activeClassName="active">
					Disturbance Report
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-technical/marpol-erb"
					className="link"
					role="menuitem"
					activeClassName="active">
					MARPOL ERB
				</Link>
			</li>
		</ul>
	</>
)

const Operation = () => (
	<>
		<h1 className="mb-20 font-bold text-base text-jetblack">Cloud Operation</h1>
		<ul>
			<li className="navigation">
				<Link
					to="/cloud-operation/charter"
					className="link"
					role="menuitem"
					activeClassName="text-tealblue">
					Charter
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-operation/offhires-and-claims"
					className="link"
					role="menuitem"
					activeClassName="active">
					Off-hires & Claims
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-operation/schedules-and-agents"
					className="link"
					role="menuitem"
					activeClassName="active">
					Schedules & Agents
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-operation/world-map"
					className="link"
					role="menuitem"
					activeClassName="active">
					World Map
				</Link>
			</li>
		</ul>
	</>
)

const Maintenance = () => (
	<>
		<h1 className="mb-20 font-bold text-base text-jetblack">Cloud Maintenance</h1>
		<ul>
			<li className="navigation">
				<Link
					to="/cloud-maintenance/maintenance"
					className="link"
					role="menuitem"
					activeClassName="active">
					Maintenance
				</Link>
			</li>
		</ul>
	</>
)

const Purchase = () => (
	<>
		<h1 className="mb-20 font-bold text-base text-jetblack">Cloud Purchase</h1>
		<ul>
			<li className="navigation">
				<Link
					to="/cloud-purchase/purchase"
					className="link"
					role="menuitem"
					activeClassName="active">
					Purchase
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-purchase/inventory"
					className="link"
					role="menuitem"
					activeClassName="active">
					Inventory
				</Link>
			</li>
		</ul>
	</>
)

const Efficiency = () => (
	<>
		<h1 className="mb-20 font-bold text-base text-jetblack">Cloud Efficiency</h1>
		<ul>
			<li className="navigation">
				<Link
					to="/cloud-efficiency/event-reporting"
					className="link"
					role="menuitem"
					activeClassName="active">
					Event Reporting
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-efficiency/mrv"
					className="link"
					role="menuitem"
					activeClassName="active">
					MRV & IMO DCS
				</Link>
			</li>
			<li className="navigation">
				<Link
					to="/cloud-efficiency/powerbi-integration"
					className="link"
					role="menuitem"
					activeClassName="active">
					PowerBI Integration
				</Link>
			</li>
		</ul>
	</>
)

const Solutions = ({ handleBackButtonClick }) => {
	return (
		<StaticQuery
			query={graphql`
				query SolutionsQuery {
					productPortfolioImage: file(relativePath: { eq: "product-portfolio.png" }) {
						childImageSharp {
							gatsbyImageData(layout: CONSTRAINED)
						}
					}

					brochureImage: file(relativePath: { eq: "brochure.jpg" }) {
						childImageSharp {
							gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
						}
					}
				}
			`}
			render={data => (
				<li role="menubar">
					<div className="col-span-12 sm:sticky sm:top-0 sm:bg-porcelain xl:hidden pt-40">
						<h1 className="display2 text-jetblack">
							<a
								onClick={handleBackButtonClick}
								role="menuitem"
								className={`cursor-pointer flex flex-row items-center`}>
								<ArrowheadFatLeft
									className={`w-[14px] h-[22px] mr-10 text-jetblack`}
								/>
								Solutions
							</a>
						</h1>
					</div>

					<div className="grid grid-cols-12 gap-x-20 md:gap-x-40 gap-y-60 py-40">
						<div className="order-1 col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2">
							<Organisation />
						</div>
						<div className="order-2 col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2">
							<Crewing />
						</div>
						<div className="order-3 col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2">
							<Technical />
						</div>
						<div className="order-4 col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2">
							<Operation />
						</div>

						<div className="order-6 col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2">
							<QHSE />
						</div>
						<div className="order-7 col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2">
							<Efficiency />
						</div>
						<div className="order-8 col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2">
							<Purchase />
						</div>
						<div className="order-9 col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2">
							<Maintenance />
						</div>

						<aside className="order-last col-span-12 flex flex-col gap-x-40 gap-y-60 md:flex-row xl:flex-col xl:col-span-4 xl:row-span-2 xl:order-5 xl:pl-20">
							<div className="flex flex-col md:flex-row xl:flex-col gap-60">
								<div className="flex flex-col gap-y-10 flex-1">
									<div className="w-full aspect-w-16 aspect-h-9 rounded-medium overflow-hidden relative hover:cursor-pointer">
										<Link
											to="/ai"
											data-umami-event="click-learn-more-about-ai-features">
											<StaticImage
												src="../images/ai-manual-search-preview.png"
												alt="Cloud Fleet Manager AI Manual Search Preview"
												title="Cloud Fleet Manager AI Manual Search Preview"
												className="hover:cursor-pointer duration-500 hover:scale-125 z-0 object-cover object-center"
											/>
										</Link>
									</div>

									<h3 className="display3 mb-10">
										Discover our newest AI Features to make work easier and
										faster
									</h3>

									<TextLink
										light={false}
										data-umami-event="click-learn-more-about-ai-features"
										to="/ai">
										Learn more
									</TextLink>
								</div>

								<div className="flex flex-col gap-y-40 flex-1">
									<Link to={`/cloud-ship-manager/ship-client`}>
										<div className="flex flex-row gap-x-12 mr-10">
											<>
												<div className="bg-porcelain w-[75px] h-[75px] rounded-medium overflow-hidden flex-none">
													<StaticImage
														src="../images/csm.png"
														alt="Cloud Ship Manager"
														title="Cloud Ship Manager"
														className="rounded-medium w-full h-full overflow-hidden object-center object-cover"
													/>
												</div>
												<ArticlePreview
													variant="tiny"
													truncateAfterLines={2}
													category="Cloud Ship Manager"
													title="Your partner on board: Explore Cloud Ship Manager"
												/>
											</>
										</div>
									</Link>

									<a
										href="/Cloud-Fleet-Manager-Product-Brochure.pdf"
										download
										data-umami-event="download-product-brochure">
										<div className="flex flex-row gap-x-12 mr-10">
											<>
												<div className="bg-porcelain w-[75px] h-[75px] rounded-medium overflow-hidden flex-none">
													<div className="bg-tealblue rounded-medium w-full h-full overflow-hidden flex justify-center items-center">
														<svg
															width="40"
															height="40"
															viewBox="0 0 40 40"
															fill="none"
															xmlns="http://www.w3.org/2000/svg">
															<path
																fillRule="evenodd"
																clipRule="evenodd"
																d="M21.6665 22.643L28.8213 15.4882L31.1783 17.8452L19.9998 29.0237L8.82133 17.8452L11.1783 15.4882L18.3332 22.643V5H21.6665V22.643ZM33.3332 31.6667V35H6.6665V31.6667H33.3332Z"
																fill="white"
															/>
														</svg>
													</div>
												</div>
												<ArticlePreview
													variant="tiny"
													truncateAfterLines={2}
													category="Product Brochure"
													title="Download our latest product brochure and learn about our solutions"
												/>
											</>
										</div>
									</a>
								</div>
							</div>
						</aside>
					</div>
				</li>
			)}
		/>
	)
}

export default Solutions
